import React from "react";
import { fmtUSDStrict } from "@/lib/format";
import { ScrollText, Info } from "lucide-react";

const num = (n, d = 2) => Number(n).toLocaleString("en-US", { maximumFractionDigits: d });

/** Exchange contract disclosure. Bulk commodities trade in fixed lots (an LME
 *  copper lot is 25 tonnes) — the client must see that, and our minimum, before buying. */
export const ContractNote = ({ contract, price, unit, qty }) => {
  if (!contract) return null;
  const lotNotional = contract.lot_size * price;
  const lots = qty ? qty / contract.lot_size : 0;

  return (
    <div className="rounded-xl border border-[color:var(--tharwy-lime-700)]/40 bg-[color:var(--tharwy-lime)]/10 p-3.5 space-y-2"
      data-testid="contract-note">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-[color:var(--tharwy-lime-700)]">
        <ScrollText className="h-3.5 w-3.5" /> Exchange contract
      </div>
      <div className="text-sm leading-relaxed">
        <span className="font-semibold">{contract.exchange}</span> trades{" "}
        <span className="font-semibold">{contract.code}</span> in lots of{" "}
        <span className="numeric font-semibold" data-testid="contract-lot-size">
          {num(contract.lot_size)} {contract.lot_unit}
        </span>
        {contract.note && <span className="text-muted-foreground"> ({contract.note})</span>} —{" "}
        about <span className="numeric font-semibold">{fmtUSDStrict(lotNotional)}</span> per lot at today's price.
      </div>
      <div className="flex items-start gap-1.5 text-xs text-muted-foreground leading-relaxed">
        <Info className="h-3.5 w-3.5 mt-px shrink-0" />
        <span>
          Tharwy gives you fractional exposure, so you don't need a full lot: our minimum is{" "}
          <span className="numeric font-semibold text-foreground" data-testid="contract-min-order">
            {num(contract.min_order, 3)} {contract.lot_unit}
          </span>{" "}
          ({fmtUSDStrict(contract.min_order * price)}). {unit ? `Priced in ${unit}.` : ""}
        </span>
      </div>
      {qty > 0 && (
        <div className="text-xs numeric text-muted-foreground" data-testid="contract-lot-equiv">
          Your order = {num(qty, 3)} {contract.lot_unit} · {num(lots, 4)} exchange lot{lots === 1 ? "" : "s"}
        </div>
      )}
    </div>
  );
};
